import React, {Component} from 'react';
import Tile from '../Tile'

class RadarCallToAction extends Component {
  constructor(props) {
    super(props)
    this.affiliate = props.affiliate
    this.warnEspImagePath = props.warnEspRadarImagePath + '?' + Date.now()
  }

  render() {
    return (<div className='gnm-radar-call-to-action'>
      <div className='row'>
        <div className='col-sm-6'>
          <CallToAction destination={this.props.affiliate === 'kotv'
              ? "/warn-interactive-live-radar"
              : "/nextgen-live-radar"}  title={this.props.affiliate === 'kotv'
              ? "WARN Radar"
              : "NextGen Live Radar"} radarIframeSrc={this.props.stationRadarSrc}/>
        </div>
        <div className='col-sm-6'>
          <CallToAction destination="/national-radar" radarIframeSrc={this.props.nationalRadarSrc} title="National Radar"/>
        </div>
      </div>
    </div>)
  }
}

class CallToAction extends Component{
  constructor(props){
    super(props)
    this.state = {
      width: 400
    }
    this.container = false
  }

  componentDidMount(){
    this.setState({
      width: this.container.offsetWidth
    })
    
  }

  render(){
    return(
      <div className="call-to-action" ref={(e)=>{this.container = e}}>
        <a href={this.props.destination} >
          <div id="baron-widget-div-N2-4" className="baron-weather-widget" style={{
              width: this.state.width + 'px',
              height: Math.min(9*this.state.width/16,300) + 'px'
            }}>
            <iframe id="baron-widget-frame-N2-4"
                className="map-widget"
                src={this.props.radarIframeSrc}
                marginHeight="0"
                frameBorder="0"
                scrolling="no"
                width="100%"
                height="100%"
                >No iframe support
            </iframe>
          </div>
          <h5 className="text-center white-at-small">{this.props.title}</h5>
        </a>
      </div>
    )
  }
}

export default RadarCallToAction;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/RadarCallToAction/index.js